import angular from 'angular';
import f from 'odata-filter-builder';
import { CATEGORY_ADDED, CATEGORY_EDITED, CATEGORY_DELETED } from 'common/messages';
import { transformODataResponse } from 'utilities/query';
import templateUrl from './categories.html';

export default {
  templateUrl,
  bindings: {
    flex: '@',
    layout: '@'
  },
  controller: class CategoriesComponent {
    constructor($mdDialog, $scope, $state, CategoryService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        $state,
        CategoryService,
        ToastService
      });
    }

    $onInit() {
      this.columns = [{
        FieldName: 'ProductCategoryName',
        DisplayName: 'Category'
      }, {
        FieldName: 'ProductCount',
        DisplayName: 'Product Count'
      }];

      this.selectedCategories = [];
      this.query = this.CategoryService.getDefaultQuery();
      this.refreshResults();
    }

    onSearchTextChanged({ searchText }) {
      this.selectedCategories = [];
      this.searchText = searchText;
      this.query = {
        ...this.query,
        filter: f().contains('ProductCategoryName', searchText)
      };

      this.refreshResults();
    }

    onQueryChanged({ query }) {
      this.selectedCategories = [];
      this.query = query;
      this.refreshResults();
    }

    refreshResults() {
      this.promise = this.CategoryService.search(this.query);
      this.promise.then((r) => {
        this.categories = transformODataResponse(r);
      }).catch(error => this.ToastService.showError(error));
    }

    canDeleteCategories(categories) {
      if (!(categories && categories.length)) {
        return false;
      }

      return !categories.some(x => x.ProductCount > 0);
    }

    categoryAdd() {
      const scope = angular.extend(this.$scope.$new(true), {
        categoryChanged: $event => this.onCategoryAdded($event)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <category-form
                dialog-title="Add New Category"
                submit-title="Add Category"
                category-changed="categoryChanged($event)">
              </category-form>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    onCategoryAdded({ category }) {
      this.CategoryService.add(category)
        .then(() => {
          this.$mdDialog.hide();
          this.refreshResults();
          this.ToastService.showSuccess(CATEGORY_ADDED);
        }).catch(error => this.ToastService.showError(error));
    }

    categoryEdit(category) {
      const scope = angular.extend(this.$scope.$new(true), {
        categoryChanged: $event => this.onCategoryEdited($event),
        category: angular.copy(category)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <category-form
                category="category"
                dialog-title="Edit Category"
                submit-title="Save Changes"
                category-changed="categoryChanged($event)">
              </category-form>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    categoryDelete(categories) {
      const confirm = this.$mdDialog.confirm()
        .title('Are you sure?')
        .textContent('Once deleted, the selected categories cannot be recovered!')
        .ok('Delete')
        .cancel('Cancel');

      this.$mdDialog.show(confirm).then(() => {
        const promises = [];
        for (let i = categories.length - 1; i >= 0; i -= 1) {
          promises.push(this.CategoryService.delete(categories[i].ProductCategoryId));
        }

        Promise.all(promises).then(() => {
          this.ToastService.showSuccess(CATEGORY_DELETED);
          this.selectedCategories = [];
          this.refreshResults();
        }).catch((error) => {
          if (error.statusText === 'Bad Request'
            && error.data
            && error.data.Message) {
            this.ToastService.showError(error, error.data.Message);
          } else {
            this.ToastService.showError(error);
          }
        });
      });
    }

    onCategoryEdited({ category }) {
      this.CategoryService.update(category)
        .then(() => {
          this.$mdDialog.hide();
          this.selectedCategories = [];
          this.refreshResults();
          this.ToastService.showSuccess(CATEGORY_EDITED);
        }).catch(error => this.ToastService.showError(error));
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/categories/categories.component.js